(function () {
  'use strict';
  if (window.HNFamilyListing) return;

  var HOST = '[data-ntajax-container].t4s-main-collection-page,[data-ntajax-container].t4s-main-collection-search';
  var OWN = '[data-hn-family-listing]';
  var instances = new WeakMap();
  var defaults = {
    loading: 'Organizing models and finishes…',
    results: '{models} {model_label} · {products} {product_label}',
    mixedResults: '{models} {model_label} · {products} {product_label} · {other} other results',
    model: 'model',
    models: 'models',
    product: 'product',
    products: 'products',
    configurations: '{count} configurations',
    configuration: 'Choose configuration',
    colors: 'Available finishes',
    allProducts: 'View all products ({count})',
    from: 'From {price}',
    view: 'View details',
    unavailable: 'Sold out',
    previous: 'Previous',
    next: 'Next',
    loadMore: 'Load More',
    pagination: 'Model pages',
    page: 'Page {page}',
    empty: 'No results found.',
    article: 'Article',
    pageType: 'Page',
    collection: 'Collection'
  };

  function el(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (text != null) element.textContent = String(text);
    return element;
  }
  function format(template, values) {
    return String(template || '').replace(/\{(\w+)\}/g, function (all, key) {
      return values[key] == null ? all : String(values[key]);
    });
  }
  function safeLink(value) {
    try {
      var url = new URL(value || '', location.href);
      if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return null;
      var preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview && !url.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', preview);
      return url.pathname + url.search + url.hash;
    } catch (_) { return null; }
  }
  function imageUrl(value) {
    if (!value) return null;
    try {
      var url = new URL(value, location.href);
      return /^https?:$/.test(url.protocol) ? url.href : null;
    } catch (_) { return null; }
  }
  function addImage(parent, source, alt, className) {
    var src = imageUrl(source);
    if (!src) return null;
    var image = el('img', className);
    image.src = src;
    image.alt = alt || '';
    image.loading = 'lazy';
    image.decoding = 'async';
    parent.appendChild(image);
    return image;
  }
  function productEntry(mapping, node) {
    var products = mapping && mapping.products || {};
    return products[node.handle] || products[String(node.id)] || null;
  }
  function textValue(value) {
    return typeof value === 'string' ? value : value && (value.label || value.title || value.name || value.key) || '';
  }
  function configurationLabel(entry, node) {
    return textValue(entry && (entry.configuration || entry.openingType || entry.label)) || node.title;
  }
  function groupsFromNodes(nodes, mapping) {
    var groups = [], seen = new Map();
    nodes.forEach(function (node) {
      var entry = node.type === 'product' ? productEntry(mapping, node) : null;
      var family = entry && entry.familyId;
      var key = family ? 'family:' + family : (node.type || 'product') + ':' + node.id;
      var group = seen.get(key);
      if (!group) {
        var definition = family && mapping.families && mapping.families[family];
        group = { key: key, familyId: family || null, title: textValue(definition) || textValue(entry && entry.title) || node.title, nodes: [] };
        seen.set(key, group);
        groups.push(group);
      }
      group.nodes.push({ node: node, entry: entry });
    });
    return groups;
  }
  function exactGroupKey(entry) {
    return entry && (entry.groupId || entry.exactGroupKey) || null;
  }
  function colorName(color) {
    return typeof color === 'string' ? color : color && (color.name || color.label || color.value) || '';
  }
  function colorKey(name) { return String(name || '').trim().toLowerCase(); }
  function colorHandle(name) { return String(name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function nativeCardElement(node) {
    if (typeof node.nativeCardHtml !== 'string' || !node.nativeCardHtml.trim()) throw new Error('Missing native card HTML for ' + node.handle);
    var template = document.createElement('template');
    template.innerHTML = node.nativeCardHtml;
    template.content.querySelectorAll('script').forEach(function (script) { script.remove(); });
    var cards = template.content.querySelectorAll('.t4s-product[data-product-options]');
    if (cards.length !== 1 || !cards[0].classList.contains('t4s-pr-style1')) throw new Error('Unsupported native card HTML for ' + node.handle);
    var card = cards[0], options;
    try { options = JSON.parse(card.getAttribute('data-product-options')); }
    catch (_) { throw new Error('Invalid native product data for ' + node.handle); }
    if (String(options.id) !== String(node.id)) throw new Error('Native card product mismatch for ' + node.handle);
    card.querySelectorAll('[data-pr-href]').forEach(function (link) {
      if (!safeLink(link.getAttribute('href'))) throw new Error('Invalid native product link for ' + node.handle);
    });
    // Original inline styles (including the price/discount markup) stay intact.
    // Preserve any native style element emitted beside the original card too.
    template.content.querySelectorAll('style').forEach(function (style) { if (!card.contains(style)) card.prepend(style); });
    return card;
  }
  function appendExternalColors(card, group) {
    var representative = group.nodes[0], key = exactGroupKey(representative.entry);
    if (!key) return;
    var seen = new Set();
    var ownColors = representative.node.colors && representative.node.colors.length ? representative.node.colors : representative.entry.colors || [];
    ownColors.forEach(function (color) { seen.add(colorKey(colorName(color))); });
    card.querySelectorAll('[data-color-options]').forEach(function (nativeColors) {
      try { (JSON.parse(nativeColors.getAttribute('data-color-options')).color_variants || []).forEach(function (color) { seen.add(colorKey(colorName(color))); }); }
      catch (_) { /* The original theme owns this optional native widget. */ }
    });
    var links = [];
    group.nodes.slice(1).forEach(function (member) {
      if (exactGroupKey(member.entry) !== key) return;
      var colors = member.node.colors && member.node.colors.length ? member.node.colors : member.entry && member.entry.colors || [];
      colors.forEach(function (color) {
        var name = colorName(color), normalized = colorKey(name);
        if (!name || seen.has(normalized)) return;
        var url = safeLink(typeof color === 'object' && color.url || member.node.url);
        if (!url) return;
        seen.add(normalized);
        var exactPhoto = member.entry && member.entry.photoOverrides && member.entry.photoOverrides[name];
        var colorPhoto = typeof color === 'object' && color.image;
        links.push({ name: name, url: url, image: imageUrl(exactPhoto) || imageUrl(colorPhoto) });
      });
    });
    if (!links.length) return;
    var container = card.querySelector('.t4s-product-info__inner');
    if (!container) return;
    var bar = el('div', 'hn-family-external-colors');
    links.forEach(function (choice) {
      var link = el('a', 'hn-family-external-color');
      link.href = choice.url;
      link.title = choice.name;
      link.setAttribute('aria-label', choice.name);
      var value = el('span', 't4s-pr-color__value bg_color_' + colorHandle(choice.name));
      if (choice.image) value.style.backgroundImage = 'url("' + choice.image.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '")';
      link.appendChild(value);
      bar.appendChild(link);
    });
    container.appendChild(bar);
  }
  function renderCard(group, labels) {
    var first = group.nodes[0].node;
    if (first.type === 'product') {
      // The complete original native card is the representative. In particular,
      // never replace its title, image, URL, first-variant price or discount HTML
      // with the independent numeric feed fields or a different family member.
      var nativeCard = nativeCardElement(first);
      nativeCard.setAttribute('data-hn-family-key', group.key);
      nativeCard.setAttribute('data-hn-family-native-card', '');
      appendExternalColors(nativeCard, group);
      return nativeCard;
    }
    // Keep article/page/collection search results as separate result cards.
    var card = el('div', 'hn-family-card hn-family-other-card t4s-col-item');
    card.setAttribute('data-hn-family-key', group.key);
    var photo = el('a', 'hn-family-card__photo');
    var url = safeLink(first.url);
    if (url) photo.href = url;
    photo.setAttribute('aria-label', first.title);
    if (!addImage(photo, first.image, first.title)) photo.classList.add('hn-family-card__photo--empty');
    card.appendChild(photo);
    var heading = el('h3', 'hn-family-card__title');
    var link = el('a', '', first.title);
    if (url) link.href = url;
    heading.appendChild(link);
    card.appendChild(heading);
    var type = labels[first.type === 'page' ? 'pageType' : first.type] || first.type;
    if (type) card.appendChild(el('p', 'hn-family-card__detail', type));
    if (first.excerpt) card.appendChild(el('p', 'hn-family-card__excerpt', first.excerpt));
    return card;
  }

  function sourceSignature(href) {
    var url = new URL(href, location.href);
    ['page', 'view', 'hn_family_page', 'section_id', 'sections', '_'].forEach(function (key) { url.searchParams.delete(key); });
    url.hash = '';
    url.searchParams.sort();
    return url.href;
  }
  function feedUrl(href, page) {
    var url = new URL(sourceSignature(href));
    url.searchParams.set('view', 'hn-family-data');
    url.searchParams.set('page', String(page));
    return url.href;
  }
  function installHistoryEvents() {
    if (window.__hnFamilyHistoryInstalled) return;
    window.__hnFamilyHistoryInstalled = true;
    ['pushState', 'replaceState'].forEach(function (method) {
      var original = history[method];
      history[method] = function () {
        var result = original.apply(this, arguments);
        window.dispatchEvent(new Event('hn:family-location'));
        return result;
      };
    });
  }

  function init(root, mapping, suppliedLabels) {
    root = root || document;
    if (instances.has(root)) { instances.get(root).setMapping(mapping, suppliedLabels); return instances.get(root); }
    var labels = Object.assign({}, defaults, suppliedLabels || {});
    var host, grid, panel, status, list, pagination, request, timer;
    var groups = [], loadedSignature = null, loadingSignature = null, failedSignature = null, generation = 0, destroyed = false;
    var pageSize = 24, currentPage = 1, renderRevision = 0;
    var hiddenNative = new Map();
    var observer;

    function findHost() {
      if (root.matches && root.matches(HOST)) return root.isConnected ? root : null;
      return root.querySelector(HOST);
    }
    function restoreNative() {
      hiddenNative.forEach(function (previous, element) {
        if (!previous.hidden) element.removeAttribute('hidden');
        if (previous.aria == null) element.removeAttribute('aria-hidden');
        else element.setAttribute('aria-hidden', previous.aria);
        element.removeAttribute('data-hn-family-native-hidden');
      });
      hiddenNative.clear();
    }
    function hideNative() {
      if (!host || !grid) return;
      var targets = [grid].concat(Array.from(host.querySelectorAll('.t4s-prs-footer,[data-wrap-lm-prev]')));
      var containingSection = host.closest('.shopify-section');
      if (host.classList.contains('t4s-main-collection-search') && groups.some(function (group) { return group.nodes[0].node.type !== 'product'; })) {
        if (containingSection) targets = targets.concat(Array.from(containingSection.querySelectorAll('.t4s-results-others')));
      }
      targets.forEach(function (element) {
        if (!hiddenNative.has(element)) hiddenNative.set(element, { hidden: element.hasAttribute('hidden'), aria: element.getAttribute('aria-hidden') });
        element.hidden = true;
        element.setAttribute('aria-hidden', 'true');
        element.setAttribute('data-hn-family-native-hidden', '');
      });
    }
    function removePanel() {
      if (panel) panel.remove();
      panel = status = list = pagination = null;
    }
    function syncGridPresentation() {
      if (!grid || !list) return;
      list.className = grid.className + ' hn-family-listing__grid';
      var nativeStyle = grid.getAttribute('style');
      if (nativeStyle == null) list.removeAttribute('style');
      else list.setAttribute('style', nativeStyle);
    }
    function fallbackToNative(error) {
      if (request) request.abort();
      failedSignature = loadingSignature || loadedSignature || sourceSignature(location.href);
      loadingSignature = loadedSignature = null;
      restoreNative();
      removePanel();
      if (host) {
        host.dataset.hnFamilyPhase = 'fallback';
        host.dataset.hnFamilyError = error.message;
      }
      window.dispatchEvent(new CustomEvent('hn:family-listing-error', { detail: { message: error.message } }));
    }
    function initializeNativeCards() {
      var revision = ++renderRevision;
      window.requestAnimationFrame(function () {
        if (destroyed || revision !== renderRevision || !panel || !panel.isConnected) return;
        try {
          var nativeTheme = window.T4SThemeSP;
          if (nativeTheme && typeof nativeTheme.reinitProductGridItem === 'function') nativeTheme.reinitProductGridItem();
          if (nativeTheme && nativeTheme.ProductItem && typeof nativeTheme.ProductItem.resizeObserver === 'function') nativeTheme.ProductItem.resizeObserver();
          if (nativeTheme && typeof nativeTheme.AnimateOnScroll === 'function') nativeTheme.AnimateOnScroll();
        } catch (error) { fallbackToNative(error); }
      });
    }
    function ensurePanel() {
      if (panel && panel.isConnected && panel.parentElement === host) return;
      removePanel();
      panel = el('section', 'hn-family-listing');
      panel.setAttribute('data-hn-family-listing', '');
      panel.setAttribute('aria-label', labels.pagination);
      status = el('p', 'hn-family-listing__status');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      list = el('div');
      list.setAttribute('data-hn-family-native-grid', '');
      syncGridPresentation();
      pagination = el('nav', 'hn-family-listing__pages');
      pagination.setAttribute('aria-label', labels.pagination);
      panel.append(status, list, pagination);
      grid.insertAdjacentElement('beforebegin', panel);
    }
    function pageFromLocation() {
      var params = new URL(location.href).searchParams;
      return Math.max(1, parseInt(params.get('hn_family_page') || params.get('page') || '1', 10) || 1);
    }
    function writePage(page) {
      var url = new URL(location.href);
      url.searchParams.delete('page');
      if (page > 1) url.searchParams.set('hn_family_page', String(page));
      else url.searchParams.delete('hn_family_page');
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    }
    function render(page, navigate) {
      if (!panel || !host || !host.isConnected) return;
      var totalPages = Math.max(1, Math.ceil(groups.length / pageSize));
      currentPage = Math.min(Math.max(1, page || 1), totalPages);
      list.replaceChildren();
      syncGridPresentation();
      groups.slice(0, currentPage * pageSize).forEach(function (group) { list.appendChild(renderCard(group, labels)); });
      var products = groups.reduce(function (count, group) { return count + group.nodes.filter(function (member) { return member.node.type === 'product'; }).length; }, 0);
      var models = groups.filter(function (group) { return group.nodes[0].node.type === 'product'; }).length;
      var other = groups.length - models;
      status.textContent = groups.length ? format(other ? labels.mixedResults : labels.results, { models: models, products: products, other: other, model_label: models === 1 ? labels.model : labels.models, product_label: products === 1 ? labels.product : labels.products }) : labels.empty;
      pagination.replaceChildren();
      if (currentPage < totalPages) {
        // Same control as the theme's own collection pagination: one "Load More" button that appends the next models.
        var nativeMore = document.querySelector('a.t4s-loadmore-btn');
        var more = el('button', nativeMore ? nativeMore.className : 't4s-pr t4s-loadmore-btn t4s-btn t4s-btn-base');
        more.type = 'button';
        more.appendChild(el('span', '', labels.loadMore));
        more.addEventListener('click', function () { try { render(currentPage + 1, true); } catch (error) { fallbackToNative(error); } });
        pagination.appendChild(more);
      }
      panel.removeAttribute('aria-busy');
      hideNative();
      initializeNativeCards();
      if (navigate) writePage(currentPage);
      window.dispatchEvent(new CustomEvent('hn:family-listing-ready', { detail: { models: models, products: products, other: other, page: currentPage, pages: totalPages } }));
    }
    async function readPage(href, page, signal) {
      // Collection routes negotiate a different JSON resource for an
      // application/json Accept header. Request the Liquid alternate view,
      // whose body is still JSON, with the normal storefront HTML media type.
      var response = await fetch(feedUrl(href, page), { credentials: 'same-origin', signal: signal, headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Family data HTTP ' + response.status);
      var data = await response.json();
      if (!data || data.version !== 1 || !Array.isArray(data.nodes) || !data.pageInfo || Number(data.pageInfo.page) !== page || !Number.isInteger(data.total) || data.total < 0) throw new Error('Invalid family data: requested=' + page + ', actual=' + (data && data.pageInfo && data.pageInfo.page) + ', version=' + (data && data.version) + ', total=' + (data && data.total) + ', nodes=' + (data && Array.isArray(data.nodes) ? data.nodes.length : 'not-array'));
      return data;
    }
    async function load(signature) {
      var run = ++generation;
      if (request) request.abort();
      request = new AbortController();
      var signal = request.signal;
      loadingSignature = signature;
      failedSignature = null;
      host.dataset.hnFamilyPhase = 'loading';
      delete host.dataset.hnFamilyError;
      restoreNative();
      ensurePanel();
      list.replaceChildren();
      pagination.replaceChildren();
      status.textContent = labels.loading;
      panel.setAttribute('aria-busy', 'true');
      try {
        var originalNativeCard = grid.querySelector('.t4s-product');
        if (originalNativeCard && !originalNativeCard.classList.contains('t4s-pr-style1')) throw new Error('Unsupported original native card style');
        if (Array.from(grid.querySelectorAll('[data-product-options]')).some(function (card) { return !card.classList.contains('t4s-pr-style1'); })) throw new Error('Unsupported original native card style');
        var first = await readPage(signature, 1, signal);
        var pages = Number(first.pageInfo.pages);
        if (!Number.isInteger(pages) || pages < 0 || pages > 100) throw new Error('Unsupported family pagination');
        var chunks = new Array(Math.max(1, pages));
        chunks[0] = first;
        var next = 2;
        async function worker() {
          while (next <= pages) {
            var page = next++;
            chunks[page - 1] = await readPage(signature, page, signal);
          }
        }
        await Promise.all([worker(), worker()]);
        if (signal.aborted || run !== generation || destroyed || sourceSignature(location.href) !== signature) return;
        var nodes = [], seen = new Set();
        chunks.forEach(function (chunk) {
          if (chunk.total !== first.total || Number(chunk.pageInfo.pages) !== pages) throw new Error('Family result changed while loading');
          chunk.nodes.forEach(function (node) {
            if (!node || !node.id || !node.url || !node.title) throw new Error('Incomplete family result');
            if (!node.type) node.type = 'product';
            if (node.type === 'product' && (typeof node.nativeCardHtml !== 'string' || !node.nativeCardHtml.trim())) throw new Error('Missing native card HTML for ' + node.handle);
            var key = node.type + ':' + node.id;
            if (seen.has(key)) throw new Error('Duplicate family result across pages');
            seen.add(key);
            nodes.push(node);
          });
        });
        if (nodes.length !== first.total) throw new Error('Incomplete family pagination');
        // Search suggestions and non-product-only searches remain native. For
        // a truly mixed search the original non-product feed nodes stay here.
        if (first.kind === 'search' && first.performed === false) throw new Error('Search not performed');
        groups = groupsFromNodes(nodes, mapping || {});
        loadedSignature = signature;
        loadingSignature = null;
        render(pageFromLocation(), false);
        host.dataset.hnFamilyPhase = 'ready';
        delete host.dataset.hnFamilyError;
      } catch (error) {
        if (run !== generation || signal.aborted) return;
        fallbackToNative(error);
      }
    }
    function refresh(force) {
      if (destroyed) return;
      var currentHost = findHost();
      var currentGrid = currentHost && currentHost.querySelector('[data-contentlm-replace].t4s-products');
      // Do not replace the "you may also like" suggestion grid on blank search.
      if (!currentGrid || currentGrid.classList.contains('t4-suggest-products')) {
        if (request) request.abort();
        generation++;
        restoreNative();
        removePanel();
        host = grid = null;
        loadedSignature = loadingSignature = null;
        failedSignature = null;
        return;
      }
      var changed = currentHost !== host || currentGrid !== grid;
      if (changed) {
        if (request) request.abort();
        generation++;
        restoreNative();
        removePanel();
        host = currentHost;
        grid = currentGrid;
        loadedSignature = loadingSignature = null;
        failedSignature = null;
      }
      var signature = sourceSignature(location.href);
      if (!force && signature === loadedSignature && panel && panel.isConnected) {
        syncGridPresentation();
        hideNative();
        var desiredPage = Math.min(pageFromLocation(), Math.max(1, Math.ceil(groups.length / pageSize)));
        if (desiredPage !== currentPage) { try { render(desiredPage, false); } catch (error) { fallbackToNative(error); } }
        return;
      }
      if (!force && signature === loadingSignature) return;
      if (!force && signature === failedSignature) return;
      load(signature);
    }
    function schedule() { clearTimeout(timer); timer = setTimeout(function () { refresh(false); }, 80); }
    function onMutation(records) {
      var relevant = records.some(function (record) {
        var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (target && target.closest(OWN)) return false;
        var changedNodes = Array.from(record.addedNodes).concat(Array.from(record.removedNodes));
        if (changedNodes.length && changedNodes.every(function (node) { return node.nodeType === 1 && node.matches(OWN); })) return false;
        return true;
      });
      if (relevant) schedule();
    }
    installHistoryEvents();
    window.addEventListener('hn:family-location', schedule);
    window.addEventListener('popstate', schedule);
    document.addEventListener('shopify:section:load', schedule);
    observer = new MutationObserver(onMutation);
    observer.observe(root === document ? document.documentElement : root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    var controller = {
      refresh: function () { refresh(true); },
      setMapping: function (nextMapping, nextLabels) {
        mapping = nextMapping || {};
        labels = Object.assign({}, defaults, nextLabels || {});
        refresh(true);
      },
      destroy: function () {
        destroyed = true;
        generation++;
        clearTimeout(timer);
        if (request) request.abort();
        observer.disconnect();
        window.removeEventListener('hn:family-location', schedule);
        window.removeEventListener('popstate', schedule);
        document.removeEventListener('shopify:section:load', schedule);
        restoreNative();
        removePanel();
        instances.delete(root);
      }
    };
    instances.set(root, controller);
    refresh(false);
    return controller;
  }
  window.HNFamilyListing = { init: init };
}());
